export default "__VITE_ASSET__CB0926QZ__"